import {
    CUSTOM_TOKEN_TIMEOUT_PROPERTY_ID,
    ASI_TIMEOUT_PROPERTY_TYPE_ID,
    DEFAULT_CUSTOM_TOKEN_TIMEOUT_VALUE
} from "@constants/custom-session-timeout";
import { FormattedAppliedProfile } from "@idw-types/data/applied-profile/applied-profile";
import { SessionTokenTimeoutPropertyInfo } from "@idw-types/data/custom-session-timeout/session-token-timeout-property-type";
import { FormattedRpServiceConfigurationProperty } from "@idw-types/data/rp-service-configuration/rp-service-configuration-property";
import { getRpServicePropertyValueOrAppliedProfilePropertyValue } from "@utils/applied-profile-util";
import { safelyParseIntFromString } from "@utils/string-util";
import { isNullOrUndefined } from "@utils/object-util";

export const secondsToMinutes = (minutes: string) => {
    return `${safelyParseIntFromString(minutes) / 60}`;
}

export const minutesToSeconds = (minutes: string) => {
    return `${safelyParseIntFromString(minutes) * 60}`;
}

export const getSessionTokenInfo = (properties: Array<FormattedRpServiceConfigurationProperty>, appliedProfiles: Array<FormattedAppliedProfile>): SessionTokenTimeoutPropertyInfo => {
    const asiTimeoutPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, ASI_TIMEOUT_PROPERTY_TYPE_ID);
    const customTokenTimeoutPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, CUSTOM_TOKEN_TIMEOUT_PROPERTY_ID);

    return {
        asiTimeoutPropertyValue,
        customTokenTimeoutPropertyValue
    };
};

export const initializeSessionTimeoutProperties = (
    asiTimeoutPropertyValue: string,
    customTokenTimeoutPropertyValue: string,
    updateProperties: (properties: Array<{ propertyTypeId: string, newValue: string, added: boolean }>) => void
) => {
    if (isNullOrUndefined(asiTimeoutPropertyValue) && isNullOrUndefined(customTokenTimeoutPropertyValue)) {
        updateProperties([
            { propertyTypeId: CUSTOM_TOKEN_TIMEOUT_PROPERTY_ID, newValue: DEFAULT_CUSTOM_TOKEN_TIMEOUT_VALUE, added: true },
            { propertyTypeId: ASI_TIMEOUT_PROPERTY_TYPE_ID, newValue: DEFAULT_CUSTOM_TOKEN_TIMEOUT_VALUE, added: true }
        ]);
    } else if (isNullOrUndefined(asiTimeoutPropertyValue)) {
        updateProperties([
            { propertyTypeId: ASI_TIMEOUT_PROPERTY_TYPE_ID, newValue: customTokenTimeoutPropertyValue, added: true }
        ]);
    } else if (isNullOrUndefined(customTokenTimeoutPropertyValue)) {
        updateProperties([
            { propertyTypeId: CUSTOM_TOKEN_TIMEOUT_PROPERTY_ID, newValue: asiTimeoutPropertyValue, added: true }
        ]);
    } else if (asiTimeoutPropertyValue !== customTokenTimeoutPropertyValue) {
        //update the one with the lower value to the higher value
        const highestValue = Math.max(parseInt(asiTimeoutPropertyValue), parseInt(customTokenTimeoutPropertyValue));
        updateProperties([
            { propertyTypeId: CUSTOM_TOKEN_TIMEOUT_PROPERTY_ID, newValue: `${highestValue}`, added: true },
            { propertyTypeId: ASI_TIMEOUT_PROPERTY_TYPE_ID, newValue: `${highestValue}`, added: true }
        ]);
    }
}